import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { fetchActiveLessonSession } from '../api/activeLesson';

/**
 * Плашка «урок идёт» со ссылкой в рабочий список занятия.
 */
export default function ActiveLessonBanner({ title = 'Преподаватель начал урок.' }) {
  const [activeLesson, setActiveLesson] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchActiveLessonSession()
      .then((active) => {
        if (!cancelled) setActiveLesson(active);
      })
      .catch(() => {
        if (!cancelled) setActiveLesson(null);
      });
    return () => { cancelled = true; };
  }, []);

  if (!activeLesson) return null;

  const listTitle = activeLesson.work_list_title
    ? ` «${activeLesson.work_list_title}»`
    : '';

  return (
    <div className="alert alert-success active-lesson-banner" role="status">
      <strong>{title}</strong>
      {' '}
      {activeLesson.work_list_first_task_slug && activeLesson.work_list_id ? (
        <>
          Можно писать код в списке занятия.
          {' '}
          <Link
            to={`/work/${activeLesson.work_list_first_task_slug}?list=${activeLesson.work_list_id}`}
            className="btn btn-sm btn-primary"
            style={{ marginLeft: '0.35rem' }}
          >
            Открыть список урока{listTitle}
          </Link>
        </>
      ) : activeLesson.work_list_id ? (
        <span>
          Список{listTitle || ' урока'} пока пуст — преподаватель добавит задачи.
          {' '}
          <Link to="/tasks" className="link-like">Мои списки</Link>
        </span>
      ) : (
        <Link to="/tasks" className="link-like">Перейти к спискам задач</Link>
      )}
    </div>
  );
}
